import { Serializable } from "@/core/api/decorators/serializable_decorator"

/**
 * One contract in the consultant's contract history: a `CandidateModel.contractHistory[]` item,
 * from GET /nxt/rfs/consultants/{uid} (v2) and the v1 assignment read.
 * The class name is part of the API contract - the backend resolves it by name in request bodies.
 */
@Serializable
export class ContractHistoryItemModel {
  assignmentUid: string = ""
  /** The v2 counterpart of assignmentUid: a v2 engagement has a Task, not an Assignment. */
  taskId: string = ""
  /**
   * The supplier-side counterpart of taskId - the Minibid the talent was proposed
   * through. supplierAssignmentUid is the v1 equivalent, so it stays "" for a v2 row.
   */
  minibidId: string = ""
  assignmentName: string = ""
  startDate: string = ""
  endDate: string = ""
  /** Hiring manager full name. */
  requester: string = ""
  hourlyRate: number = 0
  currency: string = ""
  /** Country name. */
  location: string = ""
  contractUid: string = ""
  /** Raw contract status from the DB. */
  contractStatus: number = -1
  /** Whether the person is internal to the reading organisation. */
  isInternal: boolean = false
  /** v1 only - names an AssignmentMinibid. Empty for a v2 row; use minibidId there. */
  supplierAssignmentUid: string = ""

  constructor(data: Partial<ContractHistoryItemModel> | null = null) {
    if (data) {
      this.assignmentUid = data.assignmentUid ?? ""
      this.assignmentName = data.assignmentName ?? ""
      this.startDate = data.startDate ?? ""
      this.endDate = data.endDate ?? ""
      this.requester = data.requester ?? ""
      this.hourlyRate = data.hourlyRate ?? 0
      this.currency = data.currency ?? ""
      this.location = data.location ?? ""
      this.contractUid = data.contractUid ?? ""
      this.contractStatus = data.contractStatus ?? -1
      this.taskId = data.taskId ?? ""
      this.minibidId = data.minibidId ?? ""
      this.isInternal = data.isInternal ?? false
      this.supplierAssignmentUid = data.supplierAssignmentUid ?? ""
    }
  }
}
